import {
  ExperimentTakeoverMetaData,
  ExperimentTakeoverState,
  ExperimentTakeoverStatus,
} from 'modules/experiments/takeover/types';
import { createSelector } from 'reselect';

const getExperimentTakeoverState = (state: Record<string, any>) => state.experiments.takeover.info;

export const getExperimentTakeoverStatus = createSelector(
  [getExperimentTakeoverState],
  ({ isModalOpen, isDrawerOpen }: ExperimentTakeoverState): ExperimentTakeoverStatus => ({
    isModalOpen,
    isDrawerOpen,
  }),
);

export const getExperimentTakeoverMetaData = createSelector(
  [getExperimentTakeoverState],
  ({ source }: ExperimentTakeoverState): ExperimentTakeoverMetaData => ({
    source,
  }),
);
